import { combineReducers } from 'redux';
import aesReduxConstants from '../constants';
import mapInspectReducer from './mapInspectReducer';
import mapQuickSearchReducer from './mapQuickSearchReducer';

const mapReducer = function() {
  const constants = aesReduxConstants.MAP;

  const bboxReducer = function(state, action) {
    const defaultState = null;

    if (state === undefined) state = defaultState;

    switch (action.type) {
      case constants.STORE_BBOX:
        return action.payload;
      default:
        return state;
    }
  };

  const basemapsReducer = function(state, action) {
    const defaultState = [];

    if (state === undefined) state = defaultState;

    switch (action.type) {
      case constants.GET_BASEMAPS:
        return action.basemaps;
      default:
        return state;
    }
  };

  const stateReducer = function(state, action) {
    const defaultState = null;

    if (state === undefined) state = defaultState;

    switch (action.type) {
      case constants.STORE_MAP_STATE:
        return action.payload.mapSet;
      default:
        return state;
    }
  };

  const navReducer = function(state, action) {
    const defaultState = {
      panel: 'map-sets',
      isOpen: true,
    };

    if (state === undefined) state = defaultState;

    let diff = {};

    switch (action.type) {
      case constants.OPEN_NAV:
        if (action.panel == undefined) {
          diff = { isOpen: true };
        } else {
          diff = { panel: action.panel, isOpen: true };
        }
        break;
      case constants.CLOSE_NAV:
        diff = { isOpen: false };
        break;
      default:
        return state;
    }

    return Object.assign({}, state, diff);
  };


  const mapSetReducer = function() {
    const mapSetConstants = aesReduxConstants.MAP_SET;

    const isType = function(entity, type) {
      switch (type) {
        case 'user':
          return entity.clientId && entity.userId;
        case 'client':
          return entity.clientId && !entity.userId && entity.editable;
        case 'global':
          return entity.clientId && !entity.userId && !entity.editable;
      }

      return false;
    };

    const getIdsByType = function(entities, type) {
      const filtered = entities.filter(entity => isType(entity, type));

      return filtered.map(entity => entity.id);
    };


    // Reducers
    const createList = function(type) {
      const defaultState = [];

      return function(state, action) {
        if (state === undefined) {
          state = defaultState;
        }

        switch (action.type) {
          case `${mapSetConstants.GET_ALL}_SUCCESS`:
            if (!action.meta.useCache) return getIdsByType(action.payload, type);
            return state;

          default:
            return state;
        }
      };
    };


    const fetchingReducer = function(state, action) {
      if (state === undefined) state = false;

      switch (action.type) {
        case `${mapSetConstants.GET}_REQUEST`:
        case `${mapSetConstants.GET_ALL}_REQUEST`:
          return true;

        case `${mapSetConstants.GET}_FAILURE`:
        case `${mapSetConstants.GET}_SUCCESS`:
          return false;

        case `${mapSetConstants.GET_ALL}_FAILURE`:
        case `${mapSetConstants.GET_ALL}_SUCCESS`:
          return false;

        default:
          return state;
      }
    };

    const byIdReducer = function(state, action) {
      if (state === undefined) state = {};

      switch (action.type) {
        case `${mapSetConstants.GET_ALL}_SUCCESS`:
          if (action.meta && !action.meta.useCache) return Object.assign({}, state, normalizeByKey(action.payload, 'id'));
          return state;

        case constants.STORE_MAP_STATE:
          return normalizeByKey(action.payload.mapSets, 'id');

        case `${mapSetConstants.GET}_SUCCESS`:
          var obj = {};
          obj[action.payload.id] = action.payload;

          return Object.assign({}, state, obj);

        default:
          return state;
      }
    };

    const idsByOwner = combineReducers({
      client: createList('client'),
      global: createList('global'),
      user: createList('user'),
    });

    const cacheReducer = function(state, action) {
      if (state === undefined) state = false;

      switch (action.type) {
        case mapSetConstants.INVALIDATE_CACHE:
          return false;

        case `${mapSetConstants.GET_ALL}_SUCCESS`:
          return true;

        default:
          return state;
      }
    };

    const selectedIdReducer = function(state, action) {
      if (state === undefined) state = null;

      switch (action.type) {
        case mapSetConstants.SET_CURRENT:
          return action.payload.id;

        default:
          return state;
      }
    };

    return combineReducers({
      byId: byIdReducer,
      selectedId: selectedIdReducer,
      isFetching: fetchingReducer,
      idsByOwner,
      useCache: cacheReducer,
    });
  };

  return combineReducers({
    bbox: bboxReducer,
    inspect: mapInspectReducer,
    state: stateReducer,
    mapSets: mapSetReducer(),
    nav: navReducer,
    quickSearch: mapQuickSearchReducer,
    basemaps: basemapsReducer,
  });
};

export default mapReducer();
